// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// ** API Imports
import axios from '@src/service/axios';

import { toast } from 'react-toastify';

export const getAllowance = createAsyncThunk('allowanceSliceData/getAllowance', async () => {
    try {
        let response = await axios.get('/Allowance', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const deleteAllowance = createAsyncThunk('allowanceSliceData/deleteAllowance', async (deleteId, { dispatch }) => {
    try {
        let response = await axios.delete('/Allowance/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Allowance deleted successfully.');
        await dispatch(getAllowance());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const createAllowance = createAsyncThunk('allowanceSliceData/createAllowance', async (data, { dispatch }) => {
    try {
        let response = await axios.post('/Allowance', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Allowance added succesfully.');
        await dispatch(getAllowance());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updateAllowance = createAsyncThunk('allowanceSliceData/updateAllowance', async (data, { dispatch }) => {
    try {
        let response = await axios.put('/Allowance/' + data?.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Allowance updated succesfully.');
        await dispatch(getAllowance());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updateAllowanceStatus = createAsyncThunk('allowanceSliceData/updateAllowanceStatus', async (id, { dispatch }) => {
    try {
        let response = await axios.put('/Allowance/status/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Status Updated Succesfully');
        await dispatch(getAllowance());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const allowanceSlice = createSlice({
    name: 'allowanceSliceData',
    initialState: {
        allowance: []
    },
    extraReducers: (builder) => {
        builder.addCase(getAllowance.fulfilled, (state, action) => {
            state.allowance = action?.payload;
            return;
        });
    }
});

export default allowanceSlice.reducer;
